import React, { createContext, useContext, useState, useCallback } from "react";
import { AiModal } from "../components/CinemaAI";

const AiContext = createContext(null);
export const useAi = () => useContext(AiContext);

export const AiProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [seed, setSeed] = useState(null);
  const [context, setContext] = useState(null);
  const openAi = useCallback((s, ctx) => {
    setSeed(typeof s === "string" ? s : null);
    setContext(typeof ctx === "string" ? ctx : null);
    setOpen(true);
  }, []);
  return (
    <AiContext.Provider value={{ openAi }}>
      {children}
      <AiModal open={open} onClose={() => setOpen(false)} seed={seed} context={context} />
    </AiContext.Provider>
  );
};
